<template>
<div class="translation">
  <b-dropdown v-model="$i18n.locale" :text="$i18n.locale" variant="outline-primary" split split-variant="primary">
     <b-dropdown-item v-for="lang in getLanguageList" :key="lang.code" :value="lang.code" v-on:click="setCurrentLang(lang.code)">{{lang.name}}</b-dropdown-item>
  </b-dropdown>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import {i18n} from '@/plugins/i18n'

export default {

methods:{
  setCurrentLang(language) {
    let loaded_languages = i18n.availableLocales
    localStorage.setItem('currentTranslation', language)

    // this part checks if the language was previously loaded in i18n, if yes then dont send another API request to get all the translation
    // and set i18n translation messages to the gives language, in case language is not loaded get it with API request
    if(loaded_languages.indexOf(language) == -1) {
      this.$store.dispatch('getLangTranslation', {
        currentLang: language
      })
    } else if (loaded_languages.indexOf(language) != -1) {
      i18n.locale = language
    }
  },
  getCurrentLang() {
    this.$store.dispatch('getLangTranslation', {
      currentLang: localStorage.getItem('currentTranslation') || 'EN'
    })
  }
},
computed:{
  ...mapGetters(['getLanguageList'])
},
created() {
  this.getCurrentLang()
}
}
</script>

<style>
</style>
